import useApi from "../../api/useApi";

const usePaymentService = () => {

  const {api} = useApi()

  const userShow = (callbackSuccess, callbackValidationErrors, bookingId = null) => {
    return api(
      'get',
      (bookingId) ? 'user/payments/booking/' + bookingId : 'user/payments',
      response => callbackSuccess(response.data),
      errors => callbackValidationErrors(errors),
      error => {
        throw new Error(`Error in usePaymentService::userShow: ${error?.message || JSON.stringify(error)}`)
      },
    )
  }

  const check = (callbackSuccess, callbackValidationErrors, paymentKey) => {
    return api(
      'get',
      'payment/check/payment/' + paymentKey ,
      response => callbackSuccess(response.data),
      errors => callbackValidationErrors(errors),
      error => {
        throw new Error(`Error in usePaymentService::check: ${error?.message || JSON.stringify(error)}`)
      },
    )
  }

  return {
    userShow,
    check
  }
}
export default usePaymentService
